import { render, staticRenderFns } from "./eliminar_gestionpagare.vue?vue&type=template&id=0d40b5ba&scoped=true"
import script from "./eliminar_gestionpagare.vue?vue&type=script&lang=js"
export * from "./eliminar_gestionpagare.vue?vue&type=script&lang=js"
import style0 from "./eliminar_gestionpagare.vue?vue&type=style&index=0&id=0d40b5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40b5ba",
  null
  
)

export default component.exports